

























































































































import { PropType } from 'vue';
import { mapActions } from 'vuex';

// models
import { Answer } from '@/models/configurator/answer';
import { Question, QuestionType } from '@/models/configurator/question';

//utils
import ErrorForm from '@/mixins/error-form';
import mixins from '@/utils/mixins';
import { factory } from '@/mixins/proxyable';
import { ICreateAnswerPayload } from '@/store/modules/configurator/answer';

const baseMixins = mixins(ErrorForm, factory('answer'));

export default baseMixins.extend({
  name: 'ConfiguratorAnswerForm',
  props: {
    question: {
      type: Object as PropType<Question>,
      required: true
    },
    index: Number,
    snapshot: Number,
    configurationId: Number
  },

  data: () => ({
    valid: true,
    isLoading: false,

    choiceRules: [(v: any) => !!v || 'You must select one to continue!'],

    requiredValueRule: [
      (v: number) => v != null || 'Must must be a number value to continue!'
    ],

    QuestionType
  }),

  computed: {
    hasPrevQuestion(): boolean {
      return this.index > 0;
    }
  },

  mounted() {
    if (
      this.question.type == QuestionType.MultipleChoice ||
      this.question.type == QuestionType.NumericChoice
    ) {
      // if answer is not in choices list provided
      if (this.internalValue !== null) {
        if (!this.isAnswerInChoiceQuestion()) {
          this.internalValue = null;
          this.errors.addErrorFromString(
            'error',
            'Previously selected answer no longer applicable for configuration'
          );
        }
      } else {
        //TODO: LH - 2020-01-19 - add this to a function
        if (this.question.choices && this.question.choices!.length == 1) {
          // if only one choice is avaliable
          this.internalValue = this.question.choices![0].id;
          const computedAnswer = new Answer(
            this.question.id!,
            this.configurationId
          );

          computedAnswer.updateAnswer(this.internalValue, this.question.type);

          this.isLoading = true;

          const answerPayload: ICreateAnswerPayload = {
            answer: computedAnswer,
            snapshot: this.snapshot
          };

          this.createAnswer(answerPayload)
            .then(() => {
              return this.$emit('skipQuestion', this.index);
            })
            .catch(e => {
              if (e.response) {
                switch (e.response.status) {
                  case 500:
                    this.errors.addErrorFromString(
                      'error',
                      'Error submitting answer, check your configuration'
                    );
                    break;

                  default:
                    this.errors.extractErrorFromResponse(e.response);
                    break;
                }
              }
            })
            .finally(() => {
              this.isLoading = false;
            });
        }
      }
    }
  },

  methods: {
    ...mapActions('configuratorAnswer', ['createAnswer']),

    prevQuestion(index: number) {
      if (!this.hasPrevQuestion) return;

      this.$emit('fetchPrevQuestion', index);
      // Look into makeing the functionality on the componetn instead of emitting
    },

    minMaxRules(minVal: number, maxVal: number) {
      const minConditional = (v: number) => {
        if (minVal) {
          return v >= minVal;
        } else {
          return true;
        }
      };
      const maxConditional = (v: number) => {
        if (maxVal) {
          return v <= maxVal;
        } else {
          return true;
        }
      };
      const minRule = (v: number) =>
        minConditional(v) || `"Must be at least ${minVal}"`;

      const maxRule = (v: number) =>
        maxConditional(v) || `Must be at most ${maxVal}"`;

      const rules: ((v: number) => string | boolean)[] = [minRule, maxRule];

      return rules;
    },

    isAnswerInChoiceQuestion(): boolean {
      const choices = this.question.choices?.map(({ id }) => id);

      return Boolean(choices?.includes(this.internalValue!));
    },

    submitAnswer(question: Question, index: number) {
      if (
        question.type == QuestionType.MultipleChoice ||
        question.type == QuestionType.NumericChoice
      ) {
        if (!question.choices?.length) {
          return this.$emit('fetchNextQuestion', index);
        }
      }

      const computedAnswer = new Answer(question.id!, this.configurationId);

      computedAnswer.updateAnswer(this.internalValue, question.type);

      if ((this as any).$refs.answerForm.validate()) {
        (this as any).$refs.answerForm.resetValidation();

        this.isLoading = true;

        const answerPayload: ICreateAnswerPayload = {
          answer: computedAnswer,
          snapshot: this.snapshot
        };

        this.createAnswer(answerPayload)
          .then(() => {
            return this.$emit('fetchNextQuestion', index);
          })
          .catch(e => {
            if (e.response) {
              //TODO: LH - 2020-01-19 - remove magic numnber
              switch (e.response.status) {
                case 500:
                  this.errors.addErrorFromString(
                    'error',
                    'Error submitting answer, check your configuration'
                  );
                  break;

                default:
                  this.errors.extractErrorFromResponse(e.response);
                  break;
              }
            }
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    }
  }
});
